(function () {
  'use strict';

  /* The theme swallows clicks on same-page links, so this one scrolls itself */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-isc-scroll]') : null;
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    target.scrollIntoView(true);
  }, true);

  /* Dispatch line: 2pm UK cut-off, Monday to Friday, skipping bank holidays */
  var line = document.querySelector('[data-isc-dispatch]');
  if (!line) return;

  var CUT_OFF_SECONDS = 14 * 3600;
  /* England and Wales, from gov.uk/bank-holidays.json. The line switches itself off after the last date. */
  var BANK_HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28', '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29', '2028-08-28', '2028-12-25', '2028-12-26'];

  var ukNow = function () {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (part) { parts[part.type] = parseInt(part.value, 10); });
    return {
      date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)),
      seconds: parts.hour * 3600 + parts.minute * 60 + parts.second
    };
  };
  var isWorkingDay = function (date) {
    var day = date.getUTCDay();
    return day !== 0 && day !== 6 && BANK_HOLIDAYS.indexOf(date.toISOString().slice(0, 10)) === -1;
  };
  var nextWorkingDay = function (date) {
    var next = new Date(date.getTime());
    do { next.setUTCDate(next.getUTCDate() + 1); } while (!isWorkingDay(next));
    return next;
  };
  var formatDay = function (date) {
    return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(date);
  };

  var render = function () {
    var now = ukNow();
    if (now.date.toISOString().slice(0, 10) >= BANK_HOLIDAYS[BANK_HOLIDAYS.length - 1]) {
      line.hidden = true;
      return;
    }
    if (isWorkingDay(now.date) && now.seconds < CUT_OFF_SECONDS) {
      var minutes = Math.ceil((CUT_OFF_SECONDS - now.seconds) / 60);
      var hours = Math.floor(minutes / 60);
      line.innerHTML = 'Order within <strong>' + (hours ? hours + 'h ' : '') + (minutes % 60) + 'm</strong> for same-day dispatch';
    } else {
      line.innerHTML = 'Order now for dispatch on <strong>' + formatDay(nextWorkingDay(now.date)) + '</strong>';
    }
    line.hidden = false;
  };

  render();
  setInterval(render, 30000);
})();
